import React from 'react';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

function ArrowForward() {
  return <ArrowForwardIosIcon viewBox="0 -5.6 15 35" />;
}

export default ArrowForward;
